import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./Style/Telekom.css";
import "./Style/Menu.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "./Fonts/telegrotesknext-regular.woff";
import "./Fonts/teleicon-outline.woff";
import "./Fonts/icomoon.woff";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import { principals } from "./Config/Principals";

//setting vendor favicon
var doc = document.getElementById("favicon");
doc.setAttribute("href", `${window.REACT_APP_VENDOR}-favicon.ico`);


//setting vendor font
document.body.classList.add(window.REACT_APP_VENDOR);

const { ht, iskon } = principals;

axios.defaults.headers.common["X-PrincipalId"] =
  window.REACT_APP_VENDOR === "ht" ? ht : ht;

if (process.env.REACT_APP_ENV !== "Dev") {
  console.error = function () {};
  console.warn = function () {};
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
